import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import { openMenu, closeMenu, open_menu_state, convertDateToDdMmYyyy } from '@/function/function.js';
import { cca_config } from '@/config'; 

export default {
    name: 'factures-differees',
    components: {},
    props: ["passedConsult"],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            date_facture: '',
            forceReload: true,
            re_render: true,
            today_date: this.date_function(),
            ref_bon: '',
            display_all_loading: true,
            save_loading: false,
            loadingAnalyse: false,
            loadingExamen: false,
            is_savable: true,
            is_printable: false,
            idUser: 1,
            vm_state: open_menu_state,
            operation_saved: null,
            all_soins: null,
            soins: [],
            box1: 0,
            box2: 1,
            box3: 1,
            operation_selected: null,
            somme_encaisse: 0,
            total_analyse_restant: 0,
            analyse_to_pay_id: 0,
            analyse_to_pay_montant: 0,
            carnets: [],
            qte_medoc: [],
            index_medicament_selected: null,

            consultation_reste: 0,
            consultation_paye: 0,
            analyses_paye: 0,
            prescriptions_reste: 0,
            cat_reste: 0,
            analyse_differees: [],
            jour_visible: 0,
            // ready: false,

            // Determine s'il y a eu un paiement déjà effectué
            is_paid_before: false, //  Mettre à false par defaut
            analyse_checked: [],
            prescription_checked: [],
            consult_back: null,
            tot_base_assureur: 0,
            tot_diff_prix: 0,

            examen_checked: [],
            total_prix_examen: 0,
            examen_to_pay_id: 0,
            examen_to_pay_montant: 0,

            btn_disable: false,

            total_assureur: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },

            total_assure: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },
            prix_injectables: 0,
            p_assure: [],
            p_tot_assure: [],

            // Info prescriptions
            total_prix_medicaments: 0,
            // prix_base_med: [],
            prix_base_loading: true,
            // med_base_assureur: [],
            // med_prix_additionnel: [],

            is_ordonnance: false,
            is_soins: false,
            is_analyse: false,
            is_examen: false,
            is_consultation: false,

            // Info analyse
            p_alys_assure: [],

            // Info examen
            p_exm_assure: [],

            // Ordonnance info
            p_ord_assure: [],

            filter_bill: [
                {
                    id: 1,
                    libelle: 'Filtrer'
                },
                {
                    id: 2,
                    libelle: 'Payée'
                },
                {
                    id: 3,
                    libelle: 'En attente'
                }
            ],
            chosen_filter: {
                id: 1,
                libelle: 'Filtrer'
            },

            prix_consult: [],
            tot_consult_restant: 0,

            can_pay_with_deposit: false,
            depot_info: {},
            deposit_is_less: false,
            is_depot: false,

            is_reliquat: true,
            can_apply_reliquat: false,
            espece_is_less: false,
            reliquat_is_greater: false,
            field_is_empty: false,

            paiement: {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
                remise: 0,
            },
        }
    },

    watch: {
        chosen_filter() {
            if (this.chosen_filter.id == 2) {
                this.$router.push({ path: '/consultations-all/factures/'+this.passedConsult });
            } else if (this.chosen_filter.id == 3) {
                this.$router.push({ path: '/consultations-all/factures-en-attentes/'+this.passedConsult });
            }
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return (this.consultation) ? this.consultation.patient : null
        },

        patient_est_assure() {
            return this.$store.getters['patient_est_assure'];
        },

        info_assurance() {
            return this.$store.getters['info_assurance'];
        },

        groupe_assur_actif() {
            return this.$store.getters['groupe_assur_actif'];
        },

        consultation() {
            return this.consult_back
        },

        analyses() {
            return this.$store.getters["analyses_for_consult"]
        },

        bulletin_id() {
            return this.$store.getters["analyses_for_consult"].id
        },

        prescription() {
            return this.$store.getters["prescriptions_pharmacie"]
        },
        prix_carnet() {
            let total = 0;
            this.carnets.forEach((el) => {
                if (el.libelle == 'Apport social') {
                    total -= parseInt(el.montant)
                } else {
                    total += parseInt(el.montant)
                }
            });

            return total;
        },
        
        total_prescription_restant() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data) => {

                    // calculer le prix
                    let prix = 0
                    prix = parseInt((parseInt(data.quantite) - parseInt(data.quantite_achat)) * parseInt(data.prix))
                    total += prix;

                })
            }
            return parseInt(total);
        },
        total_prescription() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data) => {
                    // calculer le prix
                    let prix = 0
                    prix = parseInt(parseInt(data.quantite) * parseInt(data.prix))
                    total += prix;

                })
            }
            return parseInt(total);
        },
        total_analyse() {
            let total = 0;

            if (this.analyses) {
                if (this.analyses.length > 0) {
                    this.analyses.forEach(data => {
                        let prix_analyse = 0
                        prix_analyse = parseInt(data.analyse.prix)
                        total += prix_analyse;

                    })
                }
            }
            return parseInt(total);
        },

        // Total Admission
        total_admission() {
            let total = 0

            this.soins.admissions.forEach(data => {
                total += data.total
            })

            return total
        },

        total_soins() {
            let sum = 0
            if (this.soins) {
                if (this.soins.acte_total >= 0 && this.soins.consommable_total >= 0 && this.soins.injectable_total >= 0) {
                    sum = parseInt(
                        this.total_admission + this.soins.acte_total + this.soins.consommable_total + this.soins.injectable_total
                    )
                }
            } 
            return sum  
        },

        total_analyse_assure() {
            // if (this.patient && this.patient.carte_assurance) {
            //     return Math.round((this.total_analyse * (100 - this.patient.carte_assurance.ticket_moderateur)) / 100)
            // } else {
            //     return this.total_analyse
            // }
            return parseInt(this.total_analyse)
        },

        // total_examen() {
        //     this.demande_examen_consultation.forEach(element => {
        //         if (element.est_paye == 2) {
        //             this.total_prix_examen += parseInt(element.type_examen_prix)
        //         }
        //     });
        //     return this.total_prix_examen
        // },

        total() {
            let sum = 0
            if (this.consultation) {
                // if (this.total_analyse >= 0 && this.total_soins >= 0 && this.total_prescription >= 0 && this.total_examen >= 0) {
                //     sum = parseInt(this.total_analyse + this.total_soins + this.total_prescription) + this.total_prix_examen
                //     this.display_all_loading = false;
                // }

                if (
                    this.total_analyse_restant >= 0 || this.total_prix_examen >= 0 || 
                    (this.soins.acte_total >= 0 || this.soins.consommable_total >= 0 || this.soins.injectable_total >= 0) || 
                    this.total_prix_medicaments >= 0 || this.tot_consult_restant >= 0
                ) {
                    sum = parseInt(this.tot_consult_restant) + this.total_analyse_restant + this.total_prix_examen + this.soins.acte_total + 
                        this.soins.consommable_total + this.soins.injectable_total + this.total_prix_medicaments

                    this.display_all_loading = false;
                }
            }

            return sum
        },

        total_paye_assureur() {
            let total = 0
            total = this.total_assureur.consultation + this.total_assureur.analyse + this.total_assureur.examen_para + this.total_assureur.protocoles +
                    this.total_assureur.ordonnance

            return total;
        },

        total_paye_assure() {
            let total = 0
            total = this.total_assure.consultation + this.total_assure.analyse + this.total_assure.examen_para + this.total_assure.protocoles + 
                    this.total_assure.ordonnance

            return total;
        },

        canSeeFactureDiffere() {
            let facteur = false
            if(
                this.is_ordonnance == false && this.is_soins == 0 && this.is_analyse == 0 && 
                this.is_examen == 0 && this.is_consultation == false
            ) {
                facteur = false
            } else {
                facteur = true
            }
            return facteur
        },

        // canSeeFactureDiffere() {
        //     let facteur = false
        //     if(
        //         this.prescription.length == 0 && this.soins.acte_total == 0 
        //         && this.analyse_differees.length == 0 && 
        //         this.consultation_reste == 0 && this.demande_examen_consultation.length == 0
        //     ) {
        //         facteur = false
        //     } else {
        //         facteur = true
        //     }
        //     return facteur
        // },

        /**
         * Recupère l'ID des jours programmés pour les conduites à tenir
         * @returns 
         */
        jourCats() {
            return this.$store.getters['jour_cats'];
        },

        demande_examen_consultation() {
            return this.$store.getters["demande_examen_consultation"]
        },

        prix_base_assur() {
            return this.$store.getters['prix_base_assur'];
        },

        depot_patient() {
            return this.$store.getters['depot_patient'];
        },
    },

    mounted() {
        this.$store.dispatch('getGroupeAssuranceActif')

        this.date_facture = convertDateToDdMmYyyy.convertDate(new Date());

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        // >>>> Etat d'ouverture d'une caisse
        this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
            if (response == 1) {
                this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
            }
        });

        // --------------CONSULTATION
        this.$store.dispatch('getTypesForConsultation', this.passedConsult).then((response) => {
            
            this.consult_back = response

            // Verifie si le patient est assuré
            this.$store.dispatch('checkIfPatientEstAssure', response.patient_id)

            // Info Assurance
            this.$store.dispatch('getPatientInfoAssurance', { patient_id: response.patient_id })

            // Depot patient
            this.$store.dispatch('getDepotPatient', response.patient_id).then(() => {
                if (this.depot_patient.length == 0) {
                    this.can_pay_with_deposit = false
                } else {
                    this.can_pay_with_deposit = true
                }
            })

            $('.p-content').fadeIn();

            //recuperation de loperation afin de vérifier si  consultation a été soldé et recupérer les carnets
            if(response.operation_id > 0) {
                this.$store.dispatch('getAnOperation', response.operation_id).then(
                    (response) => {
                        this.prix_consult = response
                        if (!response.comptabilise || response.comptabilise == 0) {
                            this.carnets = response.enfants;
                            this.consultation_reste = parseInt(response.montant) + this.prix_carnet

                            if (this.consultation_reste > 0) {
                                this.is_consultation = true

                                this.tot_consult_restant = this.prix_consult.montant + parseInt(this.prix_carnet)

                                let base_assurance = (this.consult_back.prix_prestation > 0)?parseInt(this.consult_back.prix_prestation):0
                                if (this.patient_est_assure == 1) {
                                    this.total_assureur.consultation = this.info_assurance['taux_consultation'] * base_assurance
                                    this.total_assure.consultation = parseInt(this.consult_back.prix_assure) + parseInt(this.prix_carnet)
                                } else {
                                    this.total_assure.consultation = parseInt(this.consult_back.prix) + parseInt(this.prix_carnet)
                                }
                            }
                            
                        }
                        
                        this.display_all_loading = false;
                    }
                )
            } else {
                this.display_all_loading = false;
            }
        });

        // --------------ANALYSES
        this.$store.dispatch('getAnalysesForConsult', { consultation_id: this.passedConsult, bought: 1 }).then((response) => {
            response.forEach(data => {
                this.setStatusPaidAnalyse(data)
            })
        })

        //recuperer les prescriptions
        this.$store.dispatch('getPrescriptionsPharmacie', { consultation_id: this.passedConsult, bought: 1 }).then(() => {
            let total_assure_medoc = 0
            let total_assureur_medoc = 0

            this.prescription.forEach(data => {
                this.p_ord_assure[data.medicament_stock] = 0

                this.is_ordonnance = true
                let qte = 0
                this.qte_medoc.push(data.quantite_differe);
                qte = data.quantite_differe
                this.prescription_checked.push(data)

                /**
                 * Récupérer la base assurance si patient est assuré
                 */
                 this.total_prix_medicaments += ( data.prix * qte )
                if (this.patient_est_assure == 0) {
                    // this.total_prix_medicaments += ( data.prix * qte )
                } else {
                    // this.total_prix_medicaments += (data.base_assurance * qte)

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            total_assureur_medoc += (data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                            this.p_ord_assure[data.medicament_stock] = ( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel )
                            total_assure_medoc += this.p_ord_assure[data.medicament_stock] * qte
                        } else {
                            total_assureur_medoc += (data.base_assurance * qte * this.info_assurance['taux_consultation'])
                            this.p_ord_assure[data.medicament_stock] = ( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance )
                            total_assure_medoc += this.p_ord_assure[data.medicament_stock] * qte
                        }
                    } else {
                        total_assureur_medoc += 0
                        this.p_ord_assure[data.medicament_stock] = data.base_assurance
                        total_assure_medoc += ( data.base_assurance * qte )
                    }
                }

            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
            
        })

        //  >>>> Récupère les protocoles de soins
        this.refreshCAT()
        /**
         * Demande d'examens paracliniques différés
         */
        this.$store.dispatch('getConsultationExamen', { consultation_id: this.passedConsult, etat_paiement: 2 }).then(() => {
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0
            this.total_assureur.examen_para = 0
            this.total_assure.examen_para = 0
            this.demande_examen_consultation.forEach(element => {
                this.is_examen = true
                this.examen_checked.push(element)

                this.p_exm_assure[element.type_examen_id] = 0
                this.total_prix_examen += parseInt(element.type_examen_prix)
                if (this.patient_est_assure == 0) {
                    // this.total_prix_examen += parseInt(element.type_examen_prix)
                } else {
                    // if (element.prix_base_assureur > 0) {
                    //     tot_base_assureur += parseInt(element.prix_base_assureur)
                    //     tot_diff_prix += parseInt(element.prix_additionnel)
                    // }

                    // this.total_prix_examen += parseInt(element.base_assurance)

                    if (element.est_exlusion == 0) {
                        if (element.prix_base_assureur > 0) {
                            this.total_assureur.examen_para += (element.prix_base_assureur * this.info_assurance['taux_examen'])
                            this.p_exm_assure[element.type_examen_id] = ( ( ( 1 - this.info_assurance['taux_examen'] ) * element.prix_base_assureur ) + element.prix_additionnel )
                            this.total_assure.examen_para += this.p_exm_assure[element.type_examen_id]
                        } else {
                            this.total_assureur.examen_para += (element.base_assurance * this.info_assurance['taux_examen'])
                            this.p_exm_assure[element.type_examen_id] = ( ( 1 - this.info_assurance['taux_examen'] ) * element.base_assurance )
                            this.total_assure.examen_para += this.p_exm_assure[element.type_examen_id]
                        }
                    } else {
                        this.total_assureur.examen_para += 0
                        this.p_exm_assure[element.type_examen_id] = element.base_assurance 
                        this.total_assure.examen_para += element.base_assurance
                    }
                }
            });
        })

    },
    methods: {
        date_function: function() {
            let date = new Date()
                // let expiration_d = new Date()
                // expiration_d.setDate(date.getDate() + 15)

            let today_month = date.getMonth() + 1
                // let expir_month = expiration_d.getMonth() + 1

            this.today_date = date.getDate() + '/' + today_month + '/' + date.getFullYear()
                // this.expiration_date = expiration_d.getDate() + '/' + expir_month + '/' + expiration_d.getFullYear()

            this.ref_bon = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds() + '/' + today_month + '/' + date.getDate()
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        /**
         * Désactiver / activer un jour de conduite à tenir
         * @param {*} selector 
         */
        jChange(selector) {
            let j_deactivate = document.getElementById(selector);
            let set_param = {}

            if (j_deactivate.checked) {
                set_param = {
                    "jour_id": j_deactivate.value,
                    "etat": 0
                }

            } else {
                set_param = {
                    "jour_id": parseInt(j_deactivate.value),
                    "etat": 1
                }
            }

            this.$store.dispatch('deactiveJourCat', set_param).then(() => {
                this.refreshCAT()
            })
        },

        async refreshCAT() {
            await this.$store.dispatch('getSoinsEnCoursByConsultation', { 
                consultation_id: this.passedConsult, soins_state: 2 
            }).then((response) => {
                this.soins = response[0]
                /**
                 * Détermine les parts d'assurance (Assureur et assuré)
                 */
                this.prix_injectables = 0
                this.total_assureur.protocoles = 0
                this.total_assure.protocoles = 0

                this.soins.injectables.forEach(p_injectable => {
                    this.p_assure[p_injectable.id] = 0
                    this.p_tot_assure[p_injectable.id] = 0

                    this.prix_injectables += parseInt(p_injectable.total)

                    if (this.patient_est_assure == 0) {  
                        this.total_assureur.protocoles += 0
                        this.total_assure.protocoles += ( p_injectable.total )
                    } else {
                        
                        /**
                         * Si le patient est assuré INAM l'on applique la base INAM
                         *   sinon l'on applique le % sur le prix clinique
                         */
                        if (p_injectable.est_exclu == 0) {
                            if (this.info_assurance['raison_sociale'] == 'INAM') {
                                this.total_assureur.protocoles += Math.ceil( p_injectable.total_prestation * this.info_assurance['taux_consultation'] )
                                this.total_assure.protocoles += p_injectable.total_prix_assure
                            } else {
                                this.total_assureur.protocoles += Math.ceil( p_injectable.total * this.info_assurance['taux_consultation'] )

                                this.p_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.prix)
                                this.p_tot_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.total)
                                this.total_assure.protocoles += this.p_tot_assure[p_injectable.id]
                            }
                        } else {
                            this.total_assureur.protocoles += 0
                            this.total_assure.protocoles += ( p_injectable.total )
                        }
                        
                    }
                });

                let prix_actes = 0
                this.soins.actes.forEach(p_acte => {
                    this.is_soins = true
                    prix_actes += parseInt(p_acte.total)
                });

                let prix_consommable = 0
                this.soins.consommables.forEach(p_conso => {
                    prix_consommable += parseInt(p_conso.total)
                });

                let prix_admission = 0
                this.soins.admissions.forEach(p_hospi => {
                    prix_admission += parseInt(p_hospi.total)
                });

                this.total_assure.protocoles = ( this.total_assure.protocoles + prix_actes + prix_consommable + prix_admission )


                // if (this.patient_est_assure == 0) {     //  Non assuré
                //     this.total_assureur.protocoles = 0
                //     this.total_assureur.protocoles = ( this.prix_injectables + prix_actes + prix_consommable )
                // } else {                                //  Assuré
                //     this.total_assureur.protocoles = ( this.prix_injectables * this.info_assurance['taux_consultation'] )
                //     this.total_assure.protocoles = ( (this.prix_injectables - this.total_assureur.protocoles) + prix_actes + prix_consommable )
                // }
                
                // if (this.soins.actes.length > 0 && this.soins.consommables.length > 0 && this.soins.injectables.length > 0) { // si existe
                    // this.jour_visible = 1;
                    // this.ready = true;
                    this.$store.dispatch('getCatJourIDTraite', { id_consult: this.passedConsult, state_traite: 2 }).then(() => {
                        /**
                         * Vérifie le nombre de jour coché.. s'il ne reste qu'un seul jour coché
                         * rendre incliquable ce dernier
                         */
                        let jour_len = this.jourCats.length
                        let j = 0
                        for (let i = 0; i < jour_len; i++) {
                            let is_checked = $("#pj" + i + ":checked").val() ? true : false
                            if (is_checked == true) {
                                j++
                            }
                        }
                        if (j == 1 || jour_len == 1) {
                            for (let i = 0; i < jour_len; i++) {
                                let is_checked = $("#pj" + i + ":checked").val() ? true : false
                                if (is_checked == true) {
                                    document.getElementById("pj" + i).disabled = true;
                                }
                            }
                            this.jour_visible = 1;
                        } else {
                            for (let i = 0; i < jour_len; i++) {
                                let dd = document.getElementById("pj" + i)
                                if (dd != null) {
                                    dd.disabled = false
                                } else {
                                    this.jour_visible = 0;
                                }
                                // document.getElementById("pj" + i).disabled = false;
                            }
                        }
                    })
                // }
    
            })
        },

        updateAnalyseSelection() {
            let total_check = 0;
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0

            this.total_assureur.analyse = 0
            this.total_assure.analyse = 0

            this.analyse_checked.forEach(data => {
                let prix_analyse = 0

                prix_analyse = parseInt(data.analyse.prix)
                total_check += prix_analyse;
                if (this.patient_est_assure == 0) {
                    // prix_analyse = parseInt(data.analyse.prix)
                    // total_check += prix_analyse;
                } else {
                    // prix_analyse = parseInt(data.analyse.base_assurance)
                    // total_check += prix_analyse;

                    if (data.analyse.est_exlusion == 0) {
                        if (data.analyse.prix_base_assureur > 0) {
                            this.total_assureur.analyse += (data.analyse.prix_base_assureur * this.info_assurance['taux_analyse'])
                            this.total_assure.analyse += ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.prix_base_assureur ) + data.analyse.prix_additionnel
                        } else {
                            this.total_assureur.analyse += (data.analyse.base_assurance * this.info_assurance['taux_analyse'])
                            this.total_assure.analyse += ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.base_assurance )
                        }
                    } else {
                        this.total_assureur.analyse += 0
                        this.total_assure.analyse += data.analyse.base_assurance
                    }
                }
            })

            this.total_analyse_restant = total_check;
        },

        updateExamenSelected() {
            let total_check = 0;

            this.total_assure.examen_para = 0
            this.total_assureur.examen_para = 0

            this.examen_checked.forEach(data => {
                let prix_examen = 0
                let base_assurance = 0
                prix_examen = parseInt(data.type_examen_prix)
                base_assurance = parseInt(data.base_assurance)

                if (this.patient_est_assure == 0) {
                    total_check += prix_examen;
                } else {

                    total_check += base_assurance;

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            this.total_assureur.examen_para += (data.prix_base_assureur * this.info_assurance['taux_examen'])
                            this.total_assure.examen_para += ( ( ( 1 - this.info_assurance['taux_examen'] ) * data.prix_base_assureur ) + data.prix_additionnel )
                        } else {
                            this.total_assureur.examen_para += (data.base_assurance * this.info_assurance['taux_examen'])
                            this.total_assure.examen_para += ( ( 1 - this.info_assurance['taux_examen'] ) * data.base_assurance )
                        }
                    } else {
                        this.total_assureur.examen_para += 0
                        this.total_assure.examen_para += data.base_assurance
                    }
                }
            })

            this.total_prix_examen = total_check;

        },

        updatePrescriptionSelection() {
            // let total_check = 0;
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0

            let total_assureur_medoc = 0
            let total_assure_medoc = 0
            this.total_prix_medicaments = 0

            this.prescription_checked.forEach(data => {
                // let prix_med = 0
                let qte = 0
                
                qte = data.quantite_differe
                this.total_prix_medicaments += ( data.prix * qte )
                if (this.patient_est_assure == 0) {
                    // this.total_prix_medicaments += ( data.prix * qte )
                } else {
                    // this.total_prix_medicaments += (data.base_assurance * qte)

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            total_assureur_medoc += (data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                            total_assure_medoc += ( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel ) * qte
                        } else {
                            total_assureur_medoc += 0 //(data.base_assurance * qte * this.info_assurance['taux_consultation'])
                            total_assure_medoc += 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance ) * qte
                        }
                    } else {
                        total_assureur_medoc += 0
                        total_assure_medoc += ( data.base_assurance * qte )
                    }
                }
            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
        },


        /**
         * Valider / Différer un paiement
         * @param {*} differe 
         * @param {*} confirm_selector 
         */
        submitValider(differe, confirm_selector) {
            this.save_loading = true;
            this.btn_disable = true
            let confirm = document.getElementById(confirm_selector);
            let err = 0;

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé avoir encaissé le montant
                $('.err-msg').fadeIn(500)
                err++;
                this.save_loading = false;
                this.btn_disable = false
            }

            // +++++++++      Si confirmer via le checkbox, on enregistre    ++++++++++
            if (err == 0) {
                switch (this.operation_selected) {
                    case "consultations":
                        this.updateConsultation()
                        this.paiement.prestation = 'Bon de consultation'
                        this.paiement.categorie_operation_id = 1
                        break;
                    case "soins":
                        // Soins
                        this.saveSoinsDatas(differe)
                        this.paiement.prestation = 'Soins'
                        this.paiement.categorie_operation_id = 4
                        break;
                    case "analyses":
                        // Analyse
                        this.updateAnalyse()
                        this.paiement.prestation = 'Analyse'
                        this.paiement.categorie_operation_id = 2
                        break;
                    case "prescri":
                        // Prescriptions de médicament
                        this.savePrescriptionsDatas(differe)
                        this.paiement.prestation = 'Prescriptions'
                        this.paiement.categorie_operation_id = 5
                        break;
                    case "examen_para":
                        // Examen paraclinique
                        this.updateExamenData()
                        this.paiement.prestation = 'Examen'
                        this.paiement.categorie_operation_id = 3
                        break;
                    default:
                        break;
                }
            }

        },

        updateConsultation() {
            let to_send = [];
            to_send.push(
                { 
                    operation_id: this.consultation.operation_id 
                }
            )

            let data = {
                type_prestation: 'Consultation',
                prestation: to_send,
                depot_info: this.depot_info,
                is_with_deposit: this.can_pay_with_deposit,
                user_id: this.userCredentials.user.id
            }

            this.$store.dispatch("updateExistingOperation", data).then(() => {
                // this.forceReload = false;
                $('.modal').modal('hide');

                if (this.can_apply_reliquat) {
                    this.$store.dispatch('storeReliquat', this.paiement) 
                }

                this.$nextTick(() => {
                    this.doSuccessMsg("Enregistrement effectué avec succès")
                    this.$forceUpdate();
                    this.$router.push({ path: '/consultations-all' })
                });
            })
        },

        updateAnalyse() {
            let data = {
                type_prestation: 'Analyse',
                prestation: this.analyse_checked,
                depot_info: this.depot_info,
                is_with_deposit: this.can_pay_with_deposit,
                user_id: this.userCredentials.user.id
            }
            
            this.$store.dispatch("updateExistingOperation", data).then(() => {

                this.analyse_checked.forEach((analyse) => {
                    let facture_assur = []
                    let r_coupon = []

                    let analyse_to_send = [];
                    analyse_to_send.push(analyse)

                    let analyse_data = {
                        consult_id: this.passedConsult,
                        analyses_checked: analyse_to_send,
                        assurance_facture: facture_assur,
                        coupon: r_coupon,
                    }

                    this.$store.dispatch("solderAnalyseDiffere", analyse_data)
                })
                
                $('.modal').modal('hide');
                this.$nextTick(() => {
                    if (this.can_apply_reliquat) {
                        this.$store.dispatch('storeReliquat', this.paiement) 
                    }
                    
                    this.doSuccessMsg("Enregistrement effectué avec succès")
                    this.$forceUpdate();
                    this.$router.push({ path: '/consultations-all' })
                });
            })
        },

        updateExamenData() {
            let data = {
                type_prestation: 'Examen',
                prestation: this.examen_checked,
                depot_info: this.depot_info,
                is_with_deposit: this.can_pay_with_deposit,
                user_id: this.userCredentials.user.id
            }

            this.$store.dispatch("updateExistingOperation", data).then(() => {
                // let r_coupon = []
                let data = {
                    examen_checked: this.examen_checked,
                    est_paye: 1,
                }

                this.$store.dispatch("updateBulExamenDiffere", data)
                
                $('.modal').modal('hide');
                this.$nextTick(() => {
                    if (this.can_apply_reliquat) {
                        this.$store.dispatch('storeReliquat', this.paiement) 
                    }
                    
                    this.doSuccessMsg("Enregistrement effectué avec succès")
                    this.$forceUpdate();
                    this.$router.push({ path: '/consultations-all' })
                });
            })
        },

        saveSoinsDatas(comptabilise) {

            let assur_facture = {}

            let r_coupon = []

            // Comptabilisation
            let operation_data = {
                libelle: 'Soins effectués',
                montant: (this.patient_est_assure == 1)?this.total_assure.protocoles:this.total_soins,
                coupon: r_coupon,
                type_operation: 1,
                comptabilise: comptabilise,
                user_id: this.user_id,
                utilisateur_id: this.patient.id,
                type_utilisateur: 1,
                destination: this.compte_id,
                categorie_operation_id: 4,
                depot_info: this.depot_info,
                is_with_deposit: this.can_pay_with_deposit,
            };

            this.$store.dispatch("storeOperation", operation_data).then(() => {
                let jour_checked = [];
                $('input[name="jour_checked"]:checked').each(function() {
                    jour_checked.push(this.value)
                });

                let c_data = {
                    id_consult: this.passedConsult, 
                    operation: (comptabilise)?1:2, 
                    jours_selected: jour_checked,
                    est_assure: this.patient_est_assure,
                    assurance_facture: assur_facture,
                    solde_paiement_differe: 1,
                    coupon: r_coupon,  
                }

                this.$store.dispatch("sendStateSoinsValiderTraite", c_data).then(() => {
                    this.doAfterSuccess(comptabilise)
                    this.box2 = 0;
                })

                if (this.can_apply_reliquat) {
                    this.$store.dispatch('storeReliquat', this.paiement) 
                }
            })
        },
        savePrescriptionsDatas(comptabilise) {
            let assur_facture = {}

            //get prescriptions list
            let prescriptions_to_return = [];
            let r_coupon = []

            this.prescription_checked.forEach(data => {
                let index = this.prescription.indexOf(data);
                this.qte_medoc.push(data.quantite - data.quantite_achat);

                let prix_comptabilise = 0
                
                let b_assureur = 0

                if (this.patient_est_assure == 1) {
                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur  > 0) {
                            b_assureur = data.prix_base_assureur 
                            prix_comptabilise = ( ( 1 - this.info_assurance['taux_consultation'] ) * b_assureur ) + data.prix_additionnel
                            prix_comptabilise = prix_comptabilise * this.qte_medoc[index]
                        } else {
                            b_assureur = (data.base_assurance * this.qte_medoc[index])
                            prix_comptabilise = ( ( 1 - this.info_assurance['taux_consultation'] ) * b_assureur )
                        }
                    } else {
                        prix_comptabilise = data.base_assurance * this.qte_medoc[index]
                    }
                } else {
                    prix_comptabilise = data.prix * this.qte_medoc[index]
                }

                let prix_prestation = 0
                if (this.patient_est_assure == 0) {
                    prix_prestation = data.prix * this.qte_medoc[index]
                } else {
                    prix_prestation = data.base_assurance * this.qte_medoc[index]
                }

                //s'il reste des quantités à payer
                prescriptions_to_return.push({
                    id: data.id,
                    quantite_achat: this.qte_medoc[index],
                    prix_prestation: prix_prestation,
                    part_assure: prix_comptabilise,
                    est_differe: comptabilise,
                    est_assure: this.patient_est_assure,
                    assurance_facture: assur_facture,
                    solde_paiement_differe: 1,
                    coupon: r_coupon, 
                })
            })

            // ON FAIT UN UPDATE COTE CLINIQUE
            this.$store.dispatch("sendPrescriptionsAfterVente", {
                idConsult: this.passedConsult,
                paiement_differe: 1,
                ventes: prescriptions_to_return
            }).then(() => {
                let operation_data = {
                    libelle: 'Vente de médicaments',
                    montant: (this.patient_est_assure == 1)?this.total_assure.ordonnance:this.total_prix_medicaments,
                    coupon: r_coupon, 
                    type_operation: 1,
                    comptabilise: 1,
                    user_id: this.user_id,
                    utilisateur_id: this.patient.id,
                    type_utilisateur: 1,
                    destination: this.compte_id,
                    categorie_operation_id: 5,
                    depot_info: this.depot_info,
                    is_with_deposit: this.can_pay_with_deposit,
                };

                this.$store.dispatch("storeOperation", operation_data).then(() => {
                    this.doAfterSuccess(true)
                })

                if (this.can_apply_reliquat) {
                    this.$store.dispatch('storeReliquat', this.paiement) 
                }

            })
        },
        doAfterSuccess(comptabilise) {
            $('.modal').modal('hide')
            if (comptabilise == 0) {
                this.doSuccessMsg('L\'enregistrement a été fait. L\'encaissement a été différé');
            } else {
                this.doSuccessMsg('Enregistrement et encaissement effectués avec succès');
            }
            this.save_loading = false;
            this.is_printable = true;
            this.is_savable = false;

            this.btn_disable = false
            this.$router.push({ path: '/consultations-all' })
            confirm.checked = false
        },

        setStatusPaidAnalyse(data) {
            this.p_alys_assure[data.analyse.id] = 0
            this.$store.dispatch('getAnOperation', data.operation_id).then(
                (response) => {
                    if (response.comptabilise == false || response.comptabilise == 0) {
                        this.analyse_differees.push(data)
                        this.analyse_checked.push(data)

                        this.is_analyse = true

                        this.total_analyse_restant += parseInt(data.analyse.prix)
                        if (this.patient_est_assure == 0) {
                            // this.total_analyse_restant += parseInt(data.analyse.prix)
                        } else {
                            // if (data.analyse.prix_base_assureur > 0) {
                            //     this.tot_base_assureur += parseInt(data.analyse.prix_base_assureur)
                            //     this.tot_diff_prix += parseInt(data.analyse.prix_additionnel)
                            // }

                            // this.total_analyse_restant += parseInt(data.analyse.base_assurance)

                            if (data.analyse.est_exlusion == 0) {
                                if (data.analyse.prix_base_assureur > 0) {
                                    this.total_assureur.analyse += (data.analyse.prix_base_assureur * this.info_assurance['taux_analyse'])
                                    this.p_alys_assure[data.analyse.id] = ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.prix_base_assureur ) + data.analyse.prix_additionnel
                                    this.total_assure.analyse += this.p_alys_assure[data.analyse.id]
                                } else {
                                    this.total_assureur.analyse += (data.analyse.base_assurance * this.info_assurance['taux_analyse'])
                                    this.p_alys_assure[data.analyse.id] = ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.base_assurance )
                                    this.total_assure.analyse += this.p_alys_assure[data.analyse.id]
                                }
                            } else {
                                this.total_assureur.analyse += 0
                                this.p_alys_assure[data.analyse.id] = data.analyse.base_assurance
                                this.total_assure.analyse += data.analyse.base_assurance
                            }
                        }
                    }
                }
            )
        },
        doAfterErrorVente(error) {
            this.save_loading = false;
            this.btn_disable = false

            $('.modal').modal('hide')

            var message = ""
            error.forEach((element, index) => {
                if (index == error.length - 1) {
                    message = message + element.libelle

                } else {
                    message = message + element.libelle + " ,"
                }
            });


            this.$toasted.show('Certains articles sont indisponible :' + message, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            let to_print = "Veuillez choisir tous les éléments nécessaires pour l'enregistrement";
            if (msg)
                to_print = msg

            if (this.$toasted != null) this.$toasted.clear()

            this.$toasted.show(to_print, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        // controler la saisit des nombres de médicaments
        handleInput: function(value, index) {
            this.updateOrdonnance()

            if (parseInt(value) > 0) { //si c'est un entier saisit
                // si la quantité saisit dépasse la quantité restante à acheter
                // mettre la quantité réglémentaire
                let quantite_restante_a_acheter = parseInt(this.prescription[index].quantite_differe)

                if (value > quantite_restante_a_acheter) {
                    this.doErrorMsg("Quantité saisie incorrecte");
                    // this.qte_medoc[index] = quantite_restante_a_acheter
                    this.$set(this.qte_medoc, index, quantite_restante_a_acheter)
                }
            } else {
                // si ce n'est pas un entier
                this.qte_medoc[index] = 1
                    // this.$set(this.qte_medoc, index, 1)
            }
        },

        updateOrdonnance() {
            let total_assureur_medoc = 0
            let total_assure_medoc = 0
            this.total_prix_medicaments = 0

            let i = 0
            this.prescription_checked.forEach(data => {
                let qte = 0

                qte = this.qte_medoc[i]
                this.total_prix_medicaments += ( data.prix * qte )

                if (data.est_exlusion == 0) {
                    if (data.prix_base_assureur > 0) {
                        total_assureur_medoc += (data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                        total_assure_medoc += ( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel ) * qte
                    } else {
                        total_assureur_medoc += 0 //(data.base_assurance * qte * this.info_assurance['taux_consultation'])
                        total_assure_medoc += 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance ) * qte
                    }
                } else {
                    total_assureur_medoc += 0
                    total_assure_medoc += ( data.base_assurance * qte )
                }
                this.is_ordonnance = true
                i++
            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
        },

        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
            this.operation_selected = selector
        },
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Definit le type de facture à payer (Ex. Soin, Consultation...)
         * @param {*} type_facture 
         */
        setInvoiceType(type_facture, is_depot) {
            this.operation_selected = type_facture
            if (is_depot) {
                this.depot_info = this.depot_patient
            }
            this.is_depot = is_depot
            this.deposit_is_less = false

            const solde_disponible = (this.depot_patient.a_depense == 0)?this.depot_patient.montant:this.depot_patient.montant_restant

            switch (type_facture) {

                case 'consultations':
                    this.somme_encaisse = parseInt(this.total_assure.consultation)
                    break;
                case 'analyses':
                    // if (idSelected > 0) {
                    //     this.analyse_to_pay_id = idSelected
                    //     this.analyse_to_pay_montant = mtSelected
                    //     this.somme_encaisse = mtSelected
                    // } else {
                    //     this.somme_encaisse = (this.patient_est_assure == 0)?this.total_analyse_restant:this.total_assure.analyse
                    //     this.analyse_to_pay_id = 0
                    //     this.analyse_to_pay_montant = 0

                    //     if (this.total_analyse_restant == 0) this.doErrorMsg('Veuillez sélectionner des analyses à payer')
                    // }
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.total_analyse_restant:this.total_assure.analyse
                    this.analyse_to_pay_id = 0
                    this.analyse_to_pay_montant = 0

                    if (this.total_analyse_restant == 0) this.doErrorMsg('Veuillez sélectionner des analyses à payer')

                    break;
                case 'soins':
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.total_soins:this.total_assure.protocoles
                    break;

                case 'prescri':
                    // this.somme_encaisse = this.total_soins
                    // if (idSelected >= 0) { // pour les paiements individuels
                    //     this.index_medicament_selected = idSelected
                    //     this.somme_encaisse = parseInt(this.qte_medoc[idSelected]) * parseInt(this.prescription[idSelected].prix)
                    // } else { // pour le paiement en total
                    //     this.index_medicament_selected = -1;
                    //     this.somme_encaisse = (this.patient_est_assure == 1 && this.total_assure.ordonnance > 0)?this.total_assure.ordonnance:this.total_prix_medicaments
                    // }
                    this.index_medicament_selected = -1;
                    this.somme_encaisse = (this.patient_est_assure == 1 && this.total_assure.ordonnance > 0)?this.total_assure.ordonnance:this.total_prix_medicaments

                    if (this.total_prix_medicaments == 0) this.doErrorMsg('Veuillez sélectionner des médicaments à payer')
                    break;
                case 'examen_para':
                    // this.somme_encaisse = this.total_prix_examen
                    // if (idSelected >= 0) { // pour les paiements individuels
                    //     this.examen_to_pay_id = idSelected
                    //     this.examen_to_pay_montant = mtSelected
                    //     this.somme_encaisse = mtSelected
                    // } else { // pour le paiement en total
                    //     this.examen_to_pay_id = 0
                    //     this.examen_to_pay_montant = 0
                    //     this.somme_encaisse = (this.patient_est_assure == 0)?this.total_prix_examen:this.total_assure.examen_para
                    // }
                    this.examen_to_pay_id = 0
                    this.examen_to_pay_montant = 0
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.total_prix_examen:this.total_assure.examen_para

                    if (this.total_prix_examen == 0) this.doErrorMsg('Veuillez sélectionner des examens à payer')

                    

                    break;

                default:
                    break;
            }

            if (solde_disponible < this.somme_encaisse && is_depot) {
                this.deposit_is_less = true
            }
            
        },


        printFacture() {
            this.$refs.facture_html2Pdf.generatePdf()
        },
        triggerSousTotal() {

        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'La caisse';
                let lome_le = cca_config.VILLE+', le ' + this.date_facture;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        },

        calcReliquat() {
            if (this.paiement.montant_paye > 0) {
                if (this.paiement.montant_paye > this.somme_encaisse) {
                    // this.paiement.reliquat = 
                    this.paiement.reliquat_remis = this.paiement.montant_paye - this.somme_encaisse
                } else {
                    this.paiement.reliquat = 0
                    this.paiement.reliquat_remis = 0
                }
            } else {
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            
        },

        calcResteReliquat() {
            this.paiement.reliquat_remis = parseInt(this.paiement.reliquat_remis)
            if (!Number.isInteger(this.paiement.reliquat_remis)) {
                this.paiement.reliquat_remis = ''
                return
            }
            
            if (this.paiement.reliquat_remis >= 0) {
                let r = this.paiement.montant_paye - this.somme_encaisse
                if (this.paiement.reliquat_remis <= r) {
                    this.paiement.reliquat = r - this.paiement.reliquat_remis
                } else {
                    this.paiement.reliquat = (this.paiement.montant_paye - this.somme_encaisse)
                }
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
        },

        postponeReliquat() {
            this.paiement.reliquat_remis = 0
            this.paiement.reliquat = this.paiement.reliquat = (this.paiement.montant_paye - this.somme_encaisse)
        },

        nextToConfirm(v) {
            this.paiement.montant_paye = parseInt(this.paiement.montant_paye)
            if (!Number.isInteger(this.paiement.montant_paye)) {
                this.field_is_empty = true
                this.paiement.montant_paye = 0
                return
            }

            if (this.paiement.montant_paye < this.somme_encaisse) {
                this.espece_is_less = true
                return
            }

            let reliquat_du = this.paiement.montant_paye - this.somme_encaisse
            if (this.paiement.reliquat_remis > reliquat_du) {
                this.reliquat_is_greater = true
                return
            }

            this.paiement.montant_du = this.somme_encaisse
            this.paiement.user_id = this.user_id
            this.paiement.patient_id = this.patient.id
            this.paiement.compte_id = this.compte_id
            

            this.is_reliquat = !v
            this.can_apply_reliquat = v
        },

    }
}